import { palette, withOpacity } from './designTokens';

// Raw trace_workflows_v2.outcome_final values (not to be confused with the
// separate workflows_v2.business_outcome taxonomy field, labeled "Business
// Outcome" wherever both appear together). "(none)" is the sentinel the
// traces API uses for the empty-string (untagged) value in filter params —
// it never appears as a raw value on a trace itself.
export const OUTCOME_VALUE_LABELS = {
  failure: 'Not Completed',
  success: 'Completed',
  information: 'Completed',
  cancelled: 'Cancelled',
  acknowledged: 'Completed',
  partial: 'Partial',
  warning: 'Partial',
  timeout: 'Timed Out',
  completed: 'Completed',
  not_completed: 'Not Completed',
  '(none)': 'Pending',
  unknown: 'Unknown',
};

// Mirrors _OUTCOME_TO_AGG_COL in workers/src/workflow/clickhouse_client.py.
const OUTCOME_STATUS = {
  failure: 'danger',
  not_completed: 'danger',
  success: 'success',
  completed: 'success',
  acknowledged: 'success',
  information: 'success',
  partial: 'warning',
  warning: 'warning',
  timeout: 'warning',
  cancelled: 'muted',
  unknown: 'muted',
};

export const getOutcomeLabel = (rawOutcome) => (
  rawOutcome ? (OUTCOME_VALUE_LABELS[rawOutcome] || rawOutcome) : 'Pending'
);

export const getOutcomeColor = (rawOutcome) => {
  const status = rawOutcome ? (OUTCOME_STATUS[rawOutcome] || 'muted') : 'muted';
  if (status === 'danger') return palette.status.danger;
  if (status === 'success') return palette.status.success;
  if (status === 'warning') return palette.status.warning;
  return palette.text.muted;
};

export const getOutcomePillStyle = (rawOutcome) => {
  const color = getOutcomeColor(rawOutcome);
  return { color, backgroundColor: withOpacity(color, 12) };
};

export const OUTCOME_FILTER_HIDDEN_VALUES = new Set([
  'acknowledged',
  'information',
  'warning',
  'completed',
  'not_completed',
]);

export const getOutcomeReasonLabel = (rawReason) => {
  const reason = String(rawReason || '').trim();
  if (!reason) return '';
  if (reason === 'http_2xx') return 'HTTP 2xx';
  if (reason === 'error_span') return 'Error in trace';
  if (/^http_[45]\d\d$/.test(reason)) return 'HTTP error';
  if (reason === 'semantic_match') return 'Semantic match';
  if (reason === 'dominant_keyword' || reason === 'keyword_match') return 'Keyword match';
  if (reason === 'hard_signal') return 'Hard signal';
  return reason;
};
